export default __webpack_public_path__ + "static/media/2.8185130c.jpg";